export enum UserType {
  PATIENT = 0,
  THERAPIST = 1,
  ADMIN = 2,
}
